@if (serviceId) {
    <div class="pb-3">
        <ng-template #afterTitle>
            <app-switch-input [form]="form" id="showOutdated"
                label="service.payments.showOutdated"></app-switch-input>
        </ng-template>

        <app-card-table
            translatePrefix="service.payments."
            [tableTitle]="'service.payments.title'"
            [gridData]="$any(store.data.servicePayments$ | async)"
            [columns]="columns"
            [refreshCallback]="store.api.getServicePayments"
            [additionalFilter]="additionalFilters"
            [hideCheckboxes]="true"
            (createCallback)="create()"
            (detailCallback)="detail($event)"
            (deleteCallbackWithEvent)="delete($event)"
            [afterTitle]="afterTitle"
            [defaultSorters]="[{ column: 'validFrom', direction: 'ASC' }]"
        >
            <ng-template pTemplate="copy" let-item="item">
                <app-button
                    icon="pi-copy"
                    [text]="true"
                    styleClass="p-button-set-icon-size"
                    (clickEvent)="copy(item)"
                    [pTooltip]="'service.payments.fields.copyTooltip' | translate"
                ></app-button>
            </ng-template>

            <ng-template pTemplate="insuranceType" let-data="data">
                {{ 'enum.insuranceType.' + data | translate }}
            </ng-template>

            <ng-template pTemplate="paymentType" let-data="data">
                {{ 'billing.paymentType.' + data | translate }}
            </ng-template>

            <ng-template pTemplate="transportType" let-data="data">
                {{ 'billing.transportType.' + data | translate }}
            </ng-template>
        </app-card-table>
    </div>
}
